import React from 'react';
import { Helmet } from 'react-helmet';

function SEO({ title, description, keywords, ogImage }) {
  const siteUrl = 'https://alphanetix.io';
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
  const currentUrl = `${siteUrl}${currentPath}`;
  const fullImageUrl = ogImage?.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={currentUrl} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      <meta name="author" content="Alphanetix" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:alt" content="Alphanetix - Enterprise Integration & Automation Platform" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Alphanetix" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content="Alphanetix - Enterprise Integration & Automation Platform" />
      
      {/* Structured data — Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Alphanetix",
          "url": siteUrl,
          "logo": `${siteUrl}/images/company_logo_dark.jpg`,
          "description": "Enterprise-proven on-premise integration and automation platform, now cloud-native.",
          "sameAs": [],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "sales",
            "email": "contact@alphanetix.io"
          }
        })}
      </script>

      {/* Structured data — WebSite */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Alphanetix",
          "url": siteUrl
        })}
      </script>
      
      {/* Structured data — SoftwareApplication */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "Alphanetix",
          "applicationCategory": "BusinessApplication",
          "applicationSubCategory": "Integration Platform",
          "operatingSystem": "Cloud, On-Premise, Hybrid",
          "url": siteUrl,
          "description": description,
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2027-12-31",
            "description": "Request a personalized demo"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "150"
          },
          "featureList": [
            "No-code visual workflow builder",
            "2000+ pre-built connectors",
            "On-premise, cloud, and hybrid deployment",
            "Real-time event-driven automation",
            "Enterprise-grade security and compliance",
            "AI-powered data mapping"
          ]
        })}
      </script>
    </Helmet>
  );
}

export default SEO;